import { computed } from 'vue'

export function useTransformInputListeners(emit: (...args: any[]) => void) {
    const retrieveValue = (element: HTMLInputElement) => {
        if (element.getAttribute('type') === 'number') {
            return element.valueAsNumber
        }

        if (element.getAttribute('type') === 'checkbox') {
            return element.checked
        }

        return element.value
    }

    const targetValueEmitter = (name: string) => (e: KeyboardEvent) => {
        emit(name, retrieveValue(e.target as HTMLInputElement))
    }

    return {
        listeners: computed(() => ({
            input: targetValueEmitter('input'),
            change: targetValueEmitter('change')
        }))
    }
}
